import { render, staticRenderFns } from "./WebflowSubscriptionGrid.vue?vue&type=template&id=2328be7c&scoped=true"
import script from "./WebflowSubscriptionGrid.vue?vue&type=script&lang=js"
export * from "./WebflowSubscriptionGrid.vue?vue&type=script&lang=js"
import style0 from "./WebflowSubscriptionGrid.vue?vue&type=style&index=0&id=2328be7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328be7c",
  null
  
)

export default component.exports